import { makeStyles } from "@material-ui/core/styles";

const tabStyles = makeStyles(() => ({
  root: {
    flexGrow: 1,
    paddingRight: "0px",
  },
  paddingAll: {
    padding: "0px 20px",
  },
}));

// eslint-disable-next-line import/prefer-default-export
export { tabStyles };
